module.exports = __webpack_public_path__ + "img/tea_peng.ebb48ae1.jpeg";